export enum AssetType {
	unknown = 0,
    driver = 1000,
    car = 1,
    truck = 3,
}
